import { frontDB } from "../../../../frontDB";
import { useEffect } from "react";
import { useCertificates } from "../../useCertificates";
import styles from "./CertificatesHeader.module.css";
import { useCertificatesHeader } from "./useCertificatesHeader";
import { InputPicker, Dropdown, IconButton } from "rsuite";
import { status_types, certificateTypes } from "../../../Settings/Data/lists";
import CertificateNameSearch from "./CertificateNameSearch/CertificateNameSearch";
import { showActive, getAccessLevel } from "../../../../helperFunctions";
import { capitalizeFirstLetter } from "../../../../helperFunctions";
import { showToast } from "../../../../Components/Toast";
import { FiMenu } from "react-icons/fi";

function CertificatesHeader() {
  let { showCreateCertificate, certificates } = useCertificates();

  let { locations, location } = frontDB();

  let {
    filter,
    locationHandler,
    expireRangeHandler,
    searchInputHandler,
    periodFromHandler,
    periodToHandler,
    certificateNameHandler,
    certificateTypeNameHandler,
    setSelectedLocation,
    generatingRL,
    onExport,
  } = useCertificatesHeader();

  useEffect(() => {
    setSelectedLocation();
  }, [location]);

  let inputsStatus = "readonly";

  if (getAccessLevel() >= 3) {
    inputsStatus = "edit";
  }

  let expireRangeOptions = [
    { label: "Any Expiry Date", value: "*" },
    { label: "Expired", value: "Expired" },
    { label: "Expire in 7 days", value: "7 days" },
    { label: "Expire in 30 days", value: "30 days" },
    { label: "Expire in 60 days", value: "60 days" },
    { label: "Expire in 90 days", value: "90 days" },
    { label: "Expire in 180 days", value: "180 days" },
  ];

  locations = showActive(locations);

  let locationOptions = [
    { label: "All vessels", value: "*" },
    ...locations.map((item) => ({ label: item.name, value: item._id })),
  ];

  let certificateTypeNameOptions = [
    { label: "All types", value: "*" },
    ...certificateTypes.map((item) => ({ label: item, value: item })),
  ];

  const exportMenu = (
    <div className={styles.button_container}>
      <Dropdown
        placement="bottomEnd"
        renderToggle={(props, ref) => (
          <IconButton
            {...props}
            ref={ref}
            icon={<FiMenu style={{ height: 20, width: 30 }} />}
            appearance="subtle"
            style={{
              width: "auto",
              height: 35,
              marginLeft: 0,
              display: "flex",
              alignItems: "center",
              padding: "0 12px",
            }}
          />
        )}
      >
        <Dropdown.Item
          onClick={() => {
            onExport(filter, certificates.length);
          }}
        >
          <div style={{ marginLeft: 15, width: 200 }}>
            Export Certificates list
          </div>
        </Dropdown.Item>
        <Dropdown.Item
          disabled={inputsStatus == "readonly"}
          onClick={showCreateCertificate}
        >
          <div style={{ marginLeft: 15, width: 200 }}>Add New Certificate</div>
        </Dropdown.Item>
      </Dropdown>
    </div>
  );

  //! Render
  return (
    <>
      {/* <div className={styles.certificates_header}></div> */}
      <div className={styles.header_filter_container}>
        <div className={styles.certificates_header_title}>Certificates</div>
        <div className={styles.certificates_header_searchoptions}>
          <CertificateNameSearch
            onCertificateNameChange={certificateNameHandler}
            defaultCertificateNameId={filter?.certificateNameId}
          />
        </div>

        <InputPicker
          value={filter?.locationId}
          onChange={locationHandler}
          cleanable={false}
          placeholder="Select Vessel"
          data={locationOptions}
          style={{ width: 200 }}
        />

        <InputPicker
          value={filter?.certificateTypeName}
          onChange={certificateTypeNameHandler}
          cleanable={false}
          placeholder="All types"
          data={certificateTypeNameOptions}
          style={{ width: 200 }}
        />

        <InputPicker
          value={filter?.expireRange}
          onChange={expireRangeHandler}
          cleanable={false}
          placeholder="Select expiration period"
          data={expireRangeOptions}
          style={{ width: 200 }}
        />

        {exportMenu}
      </div>
    </>
  );
}

export default CertificatesHeader;
